interface ApiEnvelope<T> {
  data: T;
  message?: string;
  error?: number;
  status?: string;
}

export async function unwrap<T>(promise: Promise<unknown>): Promise<T> {
  const res = await promise;

  if (!res || typeof res !== "object" || !("data" in res)) {
    throw new Error("Unexpected response shape");
  }

  const envelope = res as ApiEnvelope<T>;

  if (envelope.error && envelope.error !== 0) {
    throw new Error(envelope.message || "API error");
  }

  return envelope.data;
}
